module.exports = __webpack_public_path__ + "static/img/desplazamientos-1.28f7515.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/desplazamientos-1.jpg
// module id = /1ug
// module chunks = 1